export const Logo = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="82 67 343 378"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="KIHAP"
    className={className}
  >
    <path
      d="M379 113 L379 399 M128 148 L328 148 L328 333 Q328 384 379 399 M379 225 Q358 353 143 389"
      fill="none"
      stroke="currentColor"
      strokeWidth="51"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
